export default "__VITE_ASSET__CdCMDzsC__"